/* eslint-disable react/no-danger */
import { IconExternalLink } from '@tabler/icons-react';
import { marked } from 'marked';
import Dompurify from 'dompurify';
import styles from './AiResponseContainer.module.scss';
import { Button, Icon } from '@hevoio/hevo-ui-toolkit';
import { AIResponse } from '../../interfaces/aiResponse';

// Configure marked to open links in new tab
const renderer = new marked.Renderer();
const originalLinkRenderer = renderer.link.bind(renderer);
renderer.link = (href, title, text) => {
  const html = originalLinkRenderer(href, title, text);
  return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
};

marked.setOptions({ renderer });

export default function AiResponseContent({
  response,
  onTalkToSupport,
  onResolveIssue
}: {
  response: AIResponse;
  onTalkToSupport: () => void;
  onResolveIssue: () => void;
}) {
  return (
    <div className={styles.aiResponseContent}>
      <div className='text-body-small text-gray-500 text-center'>
      <b>Note:</b> This is an AI-generated response and may not be accurate
      </div>

      <div className='overflow-auto flex-grow-1 px-6 pt-6 pb-4'>
        <div
          className={`text-label-small ${styles.summaryText}`}
          dangerouslySetInnerHTML={{
            __html: Dompurify.sanitize(marked.parse(response.summary), {
              ADD_ATTR: ['target', 'rel', 'class', 'style'],
              ADD_TAGS: ['img']
            })
          }}
        />
        <div className='mt-5'>
          {response.documents.map(document => (
            <DocumentCard key={document.id} document={document} />
          ))}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          className='text-transform-none text-secondary'
          edge='start'
          iconClassName={'pr-2 icon-size-3'}
          variation='outline'
          palette='secondary'
          onClick={() => onTalkToSupport()}
        >
          This doesn't help me
        </Button>

        <Button 
          className='text-transform-none'
          edge='end'
          iconClassName={'pr-2 icon-size-3'}
          palette='primary'
          onClick={() => onResolveIssue()}
        >
          This resolved my issue
        </Button>
      </div>
    </div>
  );
}

const DocumentCard = ({ document }: { document: AIResponse['documents'][0] }) => {
  return (
    <div className={styles.documentCard}>
      <div className='d-flex align-items-center justify-between w-100'>
        <div className='text-truncate text-label-small text-bold'>{document.title}</div>
        
        <Icon
          SVGIcon={IconExternalLink}
          size={3}
          className='text-primary'
          onClick={() => window.open(document.url, '_blank')}
        />
      </div>
      
      <div className={`text-body-small ${styles.contentPreview}`}>{document.content_preview}</div>
    </div>
  );
};
